var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.98024 13.6694H13.0202C14.0469 13.6694 14.6869 12.5561 14.1736 11.6694L9.15358 2.99605C8.64024 2.10939 7.36024 2.10939 6.84691 2.99605L1.82691 11.6694C1.31358 12.5561 1.95358 13.6694 2.98024 13.6694ZM8.00024 9.00272C7.63358 9.00272 7.33358 8.70272 7.33358 8.33605V7.00272C7.33358 6.63605 7.63358 6.33605 8.00024 6.33605C8.36691 6.33605 8.66691 6.63605 8.66691 7.00272V8.33605C8.66691 8.70272 8.36691 9.00272 8.00024 9.00272ZM7.33358 11.6694H8.66691V10.3361H7.33358V11.6694Z",
    fill: "#ECA76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.290a3b14118933547965e91ea61c5a61.svg";
export { ForwardRef as ReactComponent };